// RentCard.jsx
import React from 'react';
import {
  FaMapMarkerAlt,
  FaUserFriends,
  FaMedal,
  FaBed,
  FaStar,
  FaEye,
  FaCheckCircle
} from 'react-icons/fa';
import './PGListing.css';

function RentCard({ rent, handleClick }) {
  const isBooked = !rent.isVacant && rent.showBooked;
  const isPremium = rent.isPremium;
  const isVerified = rent.isVerified;

  return (
    <div
      className={`pg-card-wrapper ${isPremium ? 'premium-card-wrapper' : ''}`}
      onClick={() => !isBooked && handleClick(rent)}
      style={{
        cursor: isBooked ? 'not-allowed' : 'pointer',
        opacity: isBooked ? 0.6 : 1
      }}
    >
      {isBooked && (
        <div className="booked-overlay booked-top">
          <span className="booked-text">Booked</span>
        </div>
      )}

      {isPremium && (
        <div className="premium-badge">
          <FaMedal className="badge-icons-pglisitngs" />
          <span className="badge-text">Featured</span>
        </div>
      )}

      <div
        className={`pg-card ${isPremium ? 'premium-card' : ''} ${
          isVerified && !isPremium ? 'verified-border' : ''
        }`}
      >
        {/* ✅ Thumbnail from thumbnailURL */}
        <img
          src={
            rent.thumbnailURL ||
            'https://dummyimage.com/400x300/cccccc/000000&text=No+Image'
          }
          alt={rent.pgName || 'Rent Image'}
          className="pg-img"
        />

        <div className="pg-content">
          <h3>
            {rent.pgName}
            {isVerified && <FaCheckCircle className="verified-tick" />}
          </h3>

          {/* ✅ City & State */}
          <p>
            <FaMapMarkerAlt />{' '}
            {rent.city && rent.state
              ? `${rent.city}, ${rent.state}`
              : rent.city
              ? rent.city
              : rent.state
              ? rent.state
              : 'Assam'}
          </p>

          {/* ✅ Nearby Roads */}

          <p>
            <FaUserFriends /> {rent.occupancy || 'N/A'}
          </p>
          <p>
            <FaBed /> {rent.roomType || 'N/A'}
          </p>
          <p className="price">₹ {rent.rent || 'N/A'}/month</p>
            <p className="listing-id">
            Listing ID: <span>{rent.id}</span>
          </p>

                    {Array.isArray(rent.nearbyRoads) && rent.nearbyRoads.length > 0 && (
            <div className="road-slider">
              {rent.nearbyRoads.map((road, index) => (
                <div key={index} className="road-info">
                  <span className="road-icon">📍</span>
                  <span>
                    {road.name || 'Unknown Road'}
                    {road.distance ? ` (${road.distance})` : ''}
                  </span>
                </div>
              ))}
            </div>
          )}


          {/* ✅ Rating and views */}
          <p
            className="rating"
            style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
          >
            {[1, 2, 3, 4, 5].map((n) => (
              <FaStar
                key={n}
                color={
                  n <= Math.round(rent.ratingAvg || 0)
                    ? '#f5c518'
                    : '#d0d0d0'
                }
              />
            ))}
            <span className="rating-avg">
              {rent.ratingCount > 0
                ? rent.ratingAvg.toFixed(1)
                : 'No ratings'}
            </span>
            <span
              className="rating-count"
              style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
            >
              <FaEye /> <span>{rent.views || 0}</span>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default RentCard;
